export { BtnDiamondIcon } from "./BtnDiamondIcon";
